export default __webpack_public_path__ + "static/media/spotify.ecd54051.png";